globalThis.FormAutosave = (function() {
  var defaults = {
    callbacks: {
      success: function() {}
    }
  }

  function FormAutosave($form, options) {
    this.$form = $form;
    this.config = $.extend({}, defaults, options);
    this.init();
  }

  FormAutosave.initForms = function($forms) {
    $forms.each(function() {
      var formAutosave = new FormAutosave($(this));
      formAutosave.init();
    });
  }

  FormAutosave.prototype = {
    init: function() {
      var self = this,
          autoSaveTimeout = null;

      this.$form.on('change keyup', 'input,textarea,select', function() {
        self.$form.addClass('changed');

        if(autoSaveTimeout) clearTimeout(autoSaveTimeout);

        autoSaveTimeout = setTimeout(function() {
          var $autosave = self.$form.find('.autosave');

          $autosave.find('.saving').siblings('.state').hide().end().show();
          $.post(self.$form.attr('action') + '.json', self.$form.find('input,textarea,select').serialize(), function(data) {
            if(data.response) {
              self.config.callbacks.success.call(self);
              $autosave.find('.saved').siblings('.state').hide().end().show();
            } else {
              $autosave.find('.error').siblings('.state').hide().end().show();
            }

            setTimeout(function() {
              $autosave.find('.state:not(.keep-on-save)').hide();
            }, 2000);
          });
        }, 2000);
      });
    }
  }

  return FormAutosave;
})();
